import { createApp } from 'vue'
import DunCentral from './App.vue'
import router from './router'

createApp(DunCentral).use(router).mount('#app')
